import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var RelatedService = /** @class */ (function () {
    function RelatedService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.loginUrl = this.env.servicePath;
    }
    RelatedService.prototype.getRelatedDocuments = function (cardId, relationDefinition) {
        var path = this.loginUrl + "GetRelatedDocuments/" + cardId + "/" + relationDefinition;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    RelatedService.prototype.getRelationCard = function (cardId) {
        var path = this.loginUrl + "GetRelationCard/" + cardId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    RelatedService.prototype.selectHighlightCard = function (cardId, docType, docId) {
        var path = this.loginUrl + "SelectRelationCardFocus/" + cardId + "/" + docType + "/" + docId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    RelatedService.prototype.getCardListDetail = function (cardId, docType) {
        var path = this.loginUrl + "GetRelatedDocumentListDetails/" + cardId + "/" + docType;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    RelatedService.prototype.selectCard = function (cardId, docType, docId) {
        var path = this.loginUrl + "GetRelatedCardDetail/" + cardId + "/" + docType + "/" + docId;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    RelatedService.ngInjectableDef = i0.defineInjectable({ factory: function RelatedService_Factory() { return new RelatedService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: RelatedService, providedIn: "root" });
    return RelatedService;
}());
export { RelatedService };
